(function($){

	$(document).ready(function(){
		
		$(document).on('click','.btn-back-to-top', function(e){
			
			$('html, body').animate( { scrollTop: 0 }, 500);

		});
	});
	
})(jQuery);